import { matchPath } from "react-router-dom";
import { adminRoutes } from "../../app/admin-routes";

/** Only existing local Admin routes can be resumed; never arbitrary return URLs. */
export function safeLoginReturn(state: unknown): string | null {
  if (!state || typeof state !== "object" || !("from" in state)) return null;
  const from = state.from;
  if (
    !from ||
    typeof from !== "object" ||
    !("pathname" in from) ||
    typeof from.pathname !== "string"
  )
    return null;
  const path = from.pathname;
  if (
    !path.startsWith("/") ||
    path.startsWith("//") ||
    /[\\%?#\s]/u.test(path) ||
    path.includes("..")
  )
    return null;
  if (!adminRoutes.some((route) => matchPath({ path: route.path, end: true }, path))) return null;
  const search = "search" in from && typeof from.search === "string" ? from.search : "";
  if (search && (!search.startsWith("?") || /[\r\n\\]/u.test(search))) return null;
  return path + search;
}
